import styled from "styled-components";

export const StyledFooter = styled.footer`
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0.5rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    width: -webkit-fill-available;

    & .logo-row {
        margin-left: auto;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    & .select-row {
        margin-right: 3rem;
    }

    & .info-rights {
        color: #828386;
        font-size: 0.8rem;
    }

    @media only screen and (max-width: 699px) {
        & .info-rights {
            font-size: 0.7rem;
        }
    }
`;
